import { Pipe, PipeTransform } from '@angular/core';
import {QuestionResponseHistory} from '../../models/questionResponse.model';

@Pipe({
  name: 'filterByCategoryId'
})
export class FilterByCategoryIdPipe implements PipeTransform {

  transform(data: QuestionResponseHistory[], categoryId: number): QuestionResponseHistory[] {
    return data.filter(qrh => {
      return qrh.question.CategoryId === categoryId;
    }).sort((a, b) => {
      return a.question.DisplayOrder - b.question.DisplayOrder;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/pipes/filterByCategoryId/filter-by-category-id.pipe.ts